import { inject, Injectable } from '@angular/core';
import { NavigationError, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ChunkErrorHandlerService {
    private router = inject(Router);

    init(): void {
        // Catch NavigationError from router
        this.router.events
            .pipe(filter((event): event is NavigationError => event instanceof NavigationError))
            .subscribe((event) => {
                if (this.isChunkLoadError(event.error)) {
                    this.reloadOnce();
                }
            });

        // Fallback: catch unhandled promise rejections for dynamic imports
        window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
            if (this.isChunkLoadError(event.reason)) {
                this.reloadOnce();
            }
        });
    }

    private isChunkLoadError(error: unknown): boolean {
        const message = ((error as Error)?.message ?? String(error)).toLowerCase();
        return (
            message.includes('chunkloaderror') ||
            message.includes('loading chunk') ||
            message.includes('dynamically imported module') ||
            message.includes('importing a module script failed')
        );
    }

    private reloadOnce(): void {
        const key = 'chunk-reload-timestamp';
        const lastReload = sessionStorage.getItem(key);
        const now = Date.now();

        // Only reload if last reload was more than 10 seconds ago
        if (!lastReload || now - Number(lastReload) > 10_000) {
            sessionStorage.setItem(key, String(now));
            window.location.reload();
        }
    }
}